<app-loading-spinner *ngIf="isLoading" />

<div class="flex flex-row max-[1024px]:flex-wrap items-center gap-6 font-semibold text[#424242] dark:text-white mb-4 mr-5 ml-0 cursor-pointer">
    <p onclick="history.back()">Distribution Centres</p>
    <p>Centre Dashboard</p>
</div>

<div *ngIf="!isLoading">
    <div class="max-[640px]:px-4 w-full px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg">
        <div class="max-[1024px]:flex-wrap max-[1024px]:gap-4 flex flex-row justify-between items-center">
            <div class="max-[1024px]:flex-wrap max-[1024px]:gap-3 max-[1024px]:min-w-0 flex flex-row gap-6">

                <div class="flex flex-row items-center max-[1024px]:whitespace-nowrap gap-2 border-[2px] rounded-2xl px-4 py-2 cursor-pointer dark:text-textDark dark:bg-[#292929]"
                    [ngClass]="{'text-[#415CFF] border-[#415CFF]': isSelectPackingLine}" (click)="selectPackingLine()">
                    <i *ngIf="isSelectPackingLine" class="fa-solid fa-check"></i>
                    <p>Packing Line</p>
                </div>

                <div class="flex flex-row items-center max-[1024px]:whitespace-nowrap gap-2 border-[2px] rounded-2xl px-4 py-2 cursor-pointer dark:text-textDark dark:bg-[#292929]"
                    [ngClass]="{'text-[#415CFF] border-[#415CFF]': isSelectProgress}" (click)="selectProgress()">
                    <i *ngIf="isSelectProgress" class="fa-solid fa-check"></i>
                    <p>Progress</p>
                </div>

                <div class="flex flex-row items-center max-[1024px]:whitespace-nowrap gap-2 border-[2px] rounded-2xl px-4 py-2 cursor-pointer dark:text-textDark dark:bg-[#292929]"
                    [ngClass]="{'text-[#415CFF] border-[#415CFF]': isSelectViewOutForDelivery}"
                    (click)="selectViewOutForDelivery()">
                    <i *ngIf="isSelectViewOutForDelivery" class="fa-solid fa-check"></i>
                    <p>Out for Handover</p>
                </div>


                <div class="flex flex-row items-center max-[1024px]:whitespace-nowrap gap-2 border-[2px] rounded-2xl px-4 py-2 cursor-pointer dark:text-textDark dark:bg-[#292929]"
                    [ngClass]="{'text-[#415CFF] border-[#415CFF]': isSelectViewOfficers}"
                    (click)="selectViewOfficers()">
                    <i *ngIf="isSelectViewOfficers" class="fa-solid fa-check"></i>
                    <p>Officers</p>
                </div>
            </div>

            <div class="max-[1024px]:flex-wrap max-[1024px]:shrink-0 flex flex-row gap-4">
                <button class="max-[1024px]:whitespace-nowrap text-[#415CFF] border-2 border-[#415CFF] font-semibold px-4 py-1 rounded-lg"
                    (click)="editCentre()">
                    <i class="fa-solid fa-pen-to-square text-xl"></i>
                    Edit</button>

                <button class="max-[1024px]:whitespace-nowrap text-[#415CFF] border-2 border-[#415CFF] font-semibold px-4 py-1 rounded-lg"
                    (click)="viewCentre()">
                    <i class="fa-solid fa-eye text-lg"></i>
                    Details</button>
            </div>
        </div>

        <hr class="my-8 border-[1px] border-[#7F7F7F]" />

        <app-dch-packing-line class="max-[1024px]:block max-[1024px]:w-full max-[1024px]:min-w-0 max-[1024px]:max-w-full" *ngIf="isSelectPackingLine" />

        <app-target-progress-ongoing class="max-[1024px]:block max-[1024px]:w-full max-[1024px]:min-w-0 max-[1024px]:max-w-full" *ngIf="isSelectProgress" />

        <app-view-center-officers class="max-[1024px]:block max-[1024px]:w-full max-[1024px]:min-w-0 max-[1024px]:max-w-full" *ngIf="isSelectViewOfficers" />

        <app-target-out-for-delivery class="max-[1024px]:block max-[1024px]:w-full max-[1024px]:min-w-0 max-[1024px]:max-w-full" *ngIf="isSelectViewOutForDelivery" />
    </div>

</div>